import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { COMPONENT, EVENT, INTERACTION_TYPE } from '../../../constants/tracking';
import usageTracker from '../../../utils/usageTracker';
import DetailsPanel from '../details-panel/DetailsPanel';
import GoalTargetActions from './GoalTargetActions';
export default function GoalNameCell({
  row
}) {
  const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
  const {
    goalType,
    assigneeType
  } = row;

  const handleOpenDetailsPanel = () => {
    usageTracker.track(EVENT.INTERACTION, {
      interactionType: INTERACTION_TYPE.GOAL_TARGET_ACTION_VIEW,
      screen: COMPONENT.GOALS_TABLE,
      goalType,
      assigneeType
    });
    setViewDetailsOpen(true);
  };

  const handleCloseDetailsPanel = () => {
    setViewDetailsOpen(false);
  };

  return /*#__PURE__*/_jsxs(GoalTargetActions, {
    onViewDetailsClicked: handleOpenDetailsPanel,
    children: [/*#__PURE__*/_jsx(UITruncateString, {
      "data-test-id": "goal-name-text",
      children: row.goalName
    }), viewDetailsOpen && /*#__PURE__*/_jsx(DetailsPanel, {
      goalTarget: row,
      handleOnClose: handleCloseDetailsPanel
    })]
  });
}